export const categories: string[] = ["women", "men", "kids"]
